import React from 'react';
import { Link } from 'react-router-dom';
import { useLanguage } from '../../context/LanguageContext';
import { Features } from '../../assets/features/Features';


const AboutFour = () => {
    const { language } = useLanguage();
    
    return (
            <div className="section section-padding case-study-featured-area">
                <div className="container">
                    <div className="row">
                    <div className="col-xl-7 col-lg-6">
                        <div className="case-study-featured-thumb text-start">
                            <div className="truck-animation">
                                <svg viewBox="0 0 400 300" className="truck-svg">
                                    {/* Road */}
                                    <rect x="0" y="250" width="400" height="50" fill="#2c3e50" opacity="0.3"/>
                                    <line x1="0" y1="275" x2="400" y2="275" stroke="#f39c12" strokeWidth="4" strokeDasharray="20,10" className="road-line"/>
                                    
                                    {/* Moving Truck */}
                                    <g className="truck-group">
                                        {/* Truck Body */}
                                        <rect x="50" y="180" width="120" height="60" fill="#e74c3c" rx="5"/>
                                        <rect x="50" y="200" width="120" height="40" fill="#c0392b"/>
                                        
                                        {/* Truck Cabin */}
                                        <rect x="170" y="190" width="60" height="50" fill="#e74c3c" rx="5"/>
                                        <rect x="175" y="195" width="50" height="40" fill="#3498db" opacity="0.3"/>
                                        
                                        {/* Wheels */}
                                        <circle cx="90" cy="240" r="20" fill="#34495e"/>
                                        <circle cx="90" cy="240" r="12" fill="#ecf0f1"/>
                                        <circle cx="150" cy="240" r="20" fill="#34495e"/>
                                        <circle cx="150" cy="240" r="12" fill="#ecf0f1"/>
                                        
                                        {/* Boxes on truck */}
                                        <rect x="60" y="160" width="30" height="20" fill="#f39c12" opacity="0.8"/>
                                        <rect x="95" y="155" width="30" height="25" fill="#3498db" opacity="0.8"/>
                                        <rect x="130" y="162" width="25" height="18" fill="#2ecc71" opacity="0.8"/>
                                    </g>
                                    
                                    {/* Floating boxes */}
                                    <g className="floating-boxes">
                                        <rect x="280" y="150" width="40" height="30" fill="#3498db" opacity="0.6" className="box-float-1"/>
                                        <rect x="320" y="140" width="35" height="28" fill="#e74c3c" opacity="0.6" className="box-float-2"/>
                                        <rect x="300" y="120" width="30" height="25" fill="#f39c12" opacity="0.6" className="box-float-3"/>
                                    </g>
                                </svg>
                            </div>
                        </div>
                    </div>
                    <div className="col-xl-5 col-lg-6">
                        <div className="case-study-featured">
                        <div className="section-heading heading-left">
                            <span className="subtitle">{Features.ABOUT_FOUR.SUBTITLE[language]}</span>
                            <h2 className="title">{Features.ABOUT_FOUR.TITLE[language]}</h2>
                            <p>{Features.ABOUT_FOUR.PARAGRAPH_1[language]}</p>
                            <p>{Features.ABOUT_FOUR.PARAGRAPH_2[language]}</p>
                            <Link to="/contactos" className="axil-btn btn-fill-primary btn-large">{Features.ABOUT_FOUR.BUTTON[language]}</Link>
                        </div>
                        </div>
                    </div>
                </div>
            </div>
            <style jsx>{`
                .truck-animation {
                    width: 100%;
                    height: 300px;
                    position: relative;
                    display: block;
                    overflow: visible;
                }
                .truck-svg {
                    width: 100%;
                    height: 100%;
                    display: block;
                }
                .road-line {
                    animation: roadMove 2s linear infinite;
                }
                @keyframes roadMove {
                    0% { stroke-dashoffset: 0; }
                    100% { stroke-dashoffset: 30; }
                }
                .truck-group {
                    animation: truckMove 8s ease-in-out infinite;
                }
                @keyframes truckMove {
                    0%, 100% { transform: translateX(0px); }
                    50% { transform: translateX(150px); }
                }
                .box-float-1 {
                    animation: floatBox 3s ease-in-out infinite;
                }
                .box-float-2 {
                    animation: floatBox 3.5s ease-in-out infinite 0.5s;
                }
                .box-float-3 {
                    animation: floatBox 4s ease-in-out infinite 1s;
                }
                @keyframes floatBox {
                    0%, 100% { transform: translateY(0px) rotate(0deg); }
                    50% { transform: translateY(-20px) rotate(5deg); }
                }
                @media (max-width: 991px) {
                    .truck-animation {
                        display: none !important;
                    }
                }
            `}</style>
        </div>

    )
}

export default AboutFour;